module.exports = __webpack_public_path__ + "static/media/Roboto-300.fc84e998.ttf";